/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProcurementType } from './ProcurementType';
import {
    ProcurementTypeFromJSON,
    ProcurementTypeFromJSONTyped,
    ProcurementTypeToJSON,
    ProcurementTypeToJSONTyped,
} from './ProcurementType';

/**
 * 
 * @export
 * @interface CostInformation
 */
export interface CostInformation {
    /**
     * 
     * @type {number}
     * @memberof CostInformation
     */
    costs?: number | null;
    /**
     * 
     * @type {ProcurementType}
     * @memberof CostInformation
     */
    procurementType: ProcurementType;
}



/**
 * Check if a given object implements the CostInformation interface.
 */
export function instanceOfCostInformation(value: object): value is CostInformation {
    if (!('procurementType' in value) || value['procurementType'] === undefined) return false;
    return true;
}

export function CostInformationFromJSON(json: any): CostInformation {
    return CostInformationFromJSONTyped(json, false);
}

export function CostInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'costs': json['costs'] == null ? undefined : json['costs'],
        'procurementType': ProcurementTypeFromJSON(json['procurementType']),
    };
}

export function CostInformationToJSON(json: any): CostInformation {
    return CostInformationToJSONTyped(json, false);
}

export function CostInformationToJSONTyped(value?: CostInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'costs': value['costs'],
        'procurementType': ProcurementTypeToJSON(value['procurementType']),
    };
}

